import React from 'react'

import { cx } from '@/lib/utils'

// import styles from './skeleton.module.scss';

/**
 * @param {number} count - how many of these skeletons should be rendered.
 * @param {string} height - either set height in parent or if height can be dynamic set an explicit 'placeholder' height here.
 * @param {boolean} isCircle - renders skeleton as a circle.
 *
 * Notes on width:
 * if parent of this component has display: flex, make sure to set parent to flex: 1 as well,
 * otherwise set parent width of how much you'd like skeleton to expand.
 */

interface SkeletonProps {
  count?: number
  height?: string
  isCircle?: boolean
  className?: string
  as?: 'div' | 'span'
  animate?: boolean
}

export const Skeleton: React.FC<SkeletonProps> = ({
  count = 1,
  height = '100%',
  isCircle = false,
  className = '',
  as: Component = 'div',
  animate = true,
}) => {
  const skeletonClasses = cx(
    'skeleton block w-full min-w-full rounded-lg border border-white-10 p-2',
    'bg-[linear-gradient(90deg,#f0f0f0,#e0e0e0,#f0f0f0)] bg-size-[200%_100%]',
    animate && 'animate-[loading_1.25s_infinite]',
    isCircle && 'skeleton--circle rounded-full',
    className
  )

  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <Component key={index} aria-hidden style={{ height }} className={skeletonClasses} />
      ))}
    </>
  )
}
